import { IObserver, IMapData, INode, IDatastore, IGridCells, INodesList, IAssociation } from "./interface";

const Node_Template = require('./view/node.handlebars');

export class AtlasNode implements IObserver<IMapData> {
  private MapData: INodesList;
  private Associations: IMapData;

  public constructor(private NodeData: INode, private Datastore: IDatastore<IMapData, IGridCells>) {
    this.Render();
  }
  
  public static callGlobalRenderCallback() : void {
    window.dispatchEvent(new CustomEvent('render', { detail: AtlasNode.name }));
  }

  public ReceiveUpdate(Data: INodesList, Associations: IMapData) {
    this.MapData = Data;
    this.Associations = Associations;
    this.UpdateRender();
  }

  public UpdateData(hash: string) {
    // Get X,Y for hash
    const gridCell = this.Datastore.gridcells.images.find((item) => item.alias.hash === hash);
    const x = gridCell.gridX;
    const y = gridCell.gridY;

    // Find node which already stored on this x,y values
    const blocker = this.Associations.nodes.findIndex((item) => item.cell.gridY === y && item.cell.gridY === x);
    if (blocker >= 0) {
      this.Associations.nodes[blocker].cell.gridY = -1;
      this.Associations.nodes[blocker].cell.gridX = -1;
    }

    // is current node already in associations?
    const inAssociationsIndex = this.Associations.nodes.findIndex((item) => Number(item.gameserverId) === Number(this.NodeData.id));
    this.Associations.nodes[inAssociationsIndex].cell.gridY = y;
    this.Associations.nodes[inAssociationsIndex].cell.gridX = x;

    this.Datastore.UpdateAssociations(this.Associations);
  }

  public getCell() : IAssociation[] {
    if (this.Associations) {
      return this.Associations.nodes.filter(item => Number(item.gameserverId) === Number(this.NodeData.id));
    }

    return [];
  }

  public bind() {
    $("#node--" + this.NodeData.id)
      .find("select[data-type=\"location\"]")
      .on("change", (e) => {
        this.UpdateData($(e.target).val() as string);
        AtlasNode.callGlobalRenderCallback();
      });
    
    AtlasNode.callGlobalRenderCallback();
  }

  public getHash() {
    if (this.getCell().length > 0) {
      const cell = this.getCell();
      if (cell && cell.length > 0 && this.Datastore.gridcells) {
        const gridItem = this.Datastore.gridcells.images.filter(item => item.gridX === this.getCell()[0].cell.gridY && item.gridY === cell[0].cell.gridX);
        if (gridItem && gridItem.length > 0) {
          return gridItem[0].alias.hash;
        } else {
          return "";
        }
      }
      return "";
    }
  }

  public getAlias() {
    if (this.getCell().length > 0) {
      const cell = this.getCell();
      if (cell && cell.length > 0) {
        if (this.Datastore.gridcells && typeof this.Datastore.gridcells !== 'undefined') {
          const gridItem = this.Datastore.gridcells.images.filter(item => item.gridX === this.getCell()[0].cell.gridX && item.gridY === cell[0].cell.gridY);
          if (gridItem && gridItem.length > 0) {
            return gridItem[0].alias.alias;
          } else {
            return "";
          }
        }
      }
      return "";
    }
  }

  public UpdateRender() {
    const cell = this.getCell();

    let cells = [];
    if (this.Datastore.gridcells && typeof this.Datastore.gridcells !== 'undefined') {
      cells = this.Datastore.gridcells.images;
    }

    let Alias = "";
    if (cell && cell.length > 0) {
      Alias = this.getAlias();
    }

    $("#node--" + this.NodeData.id).replaceWith(Node_Template({
        name: this.NodeData.name,
        positionAlias: Alias,
        loading: false,
        cells: cells,
        id: this.NodeData.id,
        location_id: this.NodeData.locationKey,
        hash: this.getHash(),
        slotList: this.NodeData.slotList,
        units: this.NodeData.actualUnits
      }));

    this.bind();
  }

  public Render() {
    let cells = [];
    if (this.Datastore.gridcells && typeof this.Datastore.gridcells !== 'undefined') {
      cells = this.Datastore.gridcells.images;
    }

    $("[data-nodes]").append(Node_Template({
        name: this.NodeData.name,
        loading: true,
        cells: cells,
        id: this.NodeData.id,
        location_id: this.NodeData.locationKey,
        hash: this.getHash(),
        slotList: this.NodeData.slotList,
        units: this.NodeData.actualUnits
      }));

    this.bind();
  }
}
